// extracted by mini-css-extract-plugin
export var cardHeader = "_fn-1";
export var contentCard = "_fn-0";
export var headerActions = "_fn-3";
export var reorderHandle = "_fn-5";
export var titleArea = "_fn-2";
export var titleAreaWithHandle = "_fn-4";